module.exports = __webpack_public_path__ + "static/media/edngai.709fd925.jpeg";